<template>
  <div class="devices">
    <template v-if="!isLoading">
      <div class="devices__title">
        <h2 class="medium-title">Not Watched Devices</h2>
        <div class="devices__title__menubar">
          <router-link class="subhead title" tag="li" :to="{name: 'unwatcheddevices'}">Not Watched Devices</router-link>
          <router-link class="subhead title" tag="li" :to="{name: 'watcheddevices'}">Watched</router-link>
        </div>
      </div>
       <router-view />
      <div class="devices__action">
        <div class="devices__action__wrapper">
          <div class="devices__action__wrapper__search" @click.stop="focusSearch">
            <span><i class="adx-ic_search"></i></span>
            <input
              ref="search" 
              type="text" 
              name="title" 
              id="title" 
              class="search-title" 
              autocomplete="off" 
              placeholder="Search device name"
              v-model="searchText"
              @keyup="keyUp">
          </div>
          <button class="primary btn-regular" @click.stop="searchDevices">search</button>
        </div>
        <button v-if="selectedDevices.length > 0" class="primary btn-regular btn-submit" @click.stop="submit">Watch</button>
      </div>
      <div class="devices__main">
        <table v-if="devices.length > 0" class="table-devices">
          <thead>
            <th class="header-checkbox checkbox" @click.stop="toggleSelectAll">
              <div :class="['checkbox__box', selectAll ? 'selected' : '']">
                <span class="checkbox__box__ic"><i class="adx-ic_check"></i></span>
              </div>
            </th>
            <th class="header-name strong">DEVICE NAME 
              <p v-if="selectedDevices.length > 0" class="small-font selected-info">{{selectedDevices.length}} of {{ devices.length }} selected. 
                <span v-if="showLinkAllPage && !selectAllPage" class="small-font select-all" @click.stop="toggleAllPage">select all {{ maxData }} devices</span>
                <span v-if="showLinkAllPage && selectAllPage" class="small-font select-all" @click.stop="toggleAllPage">clear all {{ maxData }} devices</span>
              </p>
            </th>
            <th class="header-city strong"> CITY </th>
            <th class="header-area strong"> AREA </th>
            <th class="header-version strong"> VERSION </th>
          </thead>
          <tbody>
            <tr v-for="device in devices" :key="device.uid">
              <td class="checkbox" @click.stop="toggleSelect(device.id, device.uid, device.is_slave)">
                <div :class="['checkbox__box', isSelected(device.uid) ? 'selected' : '']">
                  <span class="checkbox__box__ic"><i class="adx-ic_check large-font"></i></span>
                </div>
              </td>
              <td class="device-name regular-font">{{device.location}}</td>
              <td class="device-name regular-font">{{device.city}}</td>
              <td class="device-name regular-font">{{device.cluster}}</td>
              <td class="device-name regular-font">{{device.version}}</td>
            </tr>
          </tbody>
        </table>
        <div v-else class="devices__main__empty">
          <img src="/img/notfound/notfound.png" alt="">
        </div>
      </div>
      <div v-if="devices.length > 0" class="devices__pagination">
        <adx-pagination :selectedPage="selectedPage" :maxPage="maxPage" @change-page="selectPage" />
      </div>
    </template>
    <template v-else>
      <div class="devices__loading">
        <adx-loading />
      </div>
    </template>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import Loading from '@/components/Loading/Primary'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { helpers } from '@/lib/validation/'

export default {
  name: 'adx-watched-devices',
  components: {
    'adx-pagination': Pagination,
    'adx-loading': Loading
  },
  props: {

  },
  data() {
    return {
      selectedPage: 1,
      maxPage: 3,
      maxData: 0,
      devices: [],
      searchText: '',
      selectedDevices: [],
      selectAll: false,
      selectAllPage: false,
      showLinkAllPage: false,
      isLoading: false,
      slave: [],
      master: [],
    }
  },
  computed: {
    
  },
  watch: {
    selectAll: function(newValue, oldValue) {
      if (newValue) {
        this.showLinkAllPage = true
      } else {
        this.showLinkAllPage = false
      }
    }
  },
  beforeCreate() {

  },
  created() {
    if (this.$route.query.title) {
      this.searchText = this.$route.query.title
    }
    this.getDevices()
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    keyUp(ev){
      this.searchText = this.$refs.search.value
      if (ev.keyCode == 13) {
        this.getDevices()
      }
    },
    searchDevices(){
      this.searchText = this.$refs.search.value
      this.getDevices()
    },
    focusSearch() {
      this.$refs.search.focus()
    },
    selectPage(page) {
      this.selectedPage = page
      this.resetCheckbox()
      this.getDevices()
    },
    getDevices() {
      (async () => {
        this.isLoading = true
        let param = {page: this.selectedPage, status: 'unwatched'}
        if (this.searchText) {
          param.title = this.searchText
        }
        const response = await api.get(apiV2.activeDevices, { params: param, needToken: true })
        this.devices = response.data.results
        // this.devices = []
        this.maxPage = response.data.max_page
        this.maxData = response.data.count
        this.isLoading = false
      })();
    },
    toggleSelect(id, uid, isSlave) {
      if (this.isSelected(uid)) {
        let index = this.selectedDevices.indexOf(uid)
        this.selectedDevices.splice(index, 1)
        if (isSlave) {
          let indexSlave = this.slave.indexOf(id)
          this.slave.splice(indexSlave, 1)
        } else{
          let indexMaster = this.master.indexOf(id)
          this.master.splice (indexMaster, 1)
        }
      } else {
        this.selectedDevices.push(uid)
        if (isSlave){
          this.slave.push(id)
        } else{
          this.master.push(id)
        }
      }
      if (this.selectedDevices.length == this.devices.length) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
    },
    isSelected(uid) {
      let devices = this.selectedDevices.filter((deviceID) => {
        return deviceID == uid
      })
      if (devices.length > 0) {
        return true
      }

      return false
    },
    toggleSelectAll() {
      this.selectAll = !this.selectAll
      // this.showLinkAllPage = !this.showLinkAllPage
      if (this.selectAll) {
        this.selectedDevices = []
        this.master = []
        this.slave = []
        this.devices.forEach((device) => {
          this.selectedDevices.push(device.uid)
          if (device.is_slave){
            this.slave.push(device.id)
          } else{
            this.master.push(device.id)
          }
        })
      } else {
        this.resetCheckbox()
      }
    },
    resetCheckbox() {
      this.selectedDevices = []
      this.master = []
      this.slave = []
      this.selectAll = false
      this.selectAllPage = false
    },
    toggleAllPage() {
      this.selectAllPage = !this.selectAllPage
      if (!this.selectAllPage) {
        this.resetCheckbox()
      }
    },
    submit() {
      (async() => {
        let data = {devices: this.master, slaves: this.slave ,status: 'unwatch'}
        if (this.selectAllPage) {
          data.all = 'all'
        }
        const response = await api.put(apiV2.deviceSetReportStatus, data, {needToken: true})
        if (response.status == 200) {
          this.$notify({
            group: 'saved',
            title: 'Success',
            text: 'Successfully add devices to watched list',
            type: 'success'
          });
          this.selectedPage = 1
          this.resetCheckbox()
          this.getDevices()
        } else {
          this.$notify({
            group: 'saved',
            title: 'Failed to watch devices',
            text: response.data.detail || response.data.message,
            type: 'danger'
          });
        }
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>